import { createTheme, ThemeProvider } from "@mui/material";

var themes = {
    default: createTheme({
        //palette: { primary: [color], secondary: [color] },

        components: {
            MuiFormControl: {
                styleOverrides: {
                    root: { margin: "10px auto" }
                }
            },

            MuiFilledInput: {
                styleOverrides: {
                    root: {
                        backgroundColor: "#FFF",
                        "&:hover": {
                            backgroundColor: "#FFFACC"
                        },
                        "&.Mui-focused": {
                            backgroundColor: "#FFFACC"
                        },
                        "&.Mui-disabled": {
                            backgroundColor: "#777"
                        }
                    }
                }
            },

            MuiFormHelperText: {
                styleOverrides: {
                    root: {
                        fontSize: "16px"
                    }
                }
            },

            MuiTextField: {
                defaultProps: {
                    variant: "filled",
                    fullWidth: true
                },

                styleOverrides: {
                    root: { margin: "10px auto" }
                }
            },

            MuiButton: {
                defaultProps: {
                    variant: "contained",
                    size: "large"
                },

                styleOverrides: {
                    root: {
                        minWidth: "200px",
                        margin: "10px auto",
                        "&.Mui-disabled": {
                            backgroundColor: "#777",
                            color: "#444"
                        }
                    }
                }
            }
        }
    })
}

export function Theme({ children, theme }) {
    theme = themes[theme && typeof theme === "string" && theme ? theme : "default"];
    return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}